function RepresentingUser(data){
    let representing = data || {};
    this.id = representing.id;
    this.firstName = representing.firstName;
    this.lastName = representing.lastName;
    this.processNumber = representing.processNumber;
    this.isDeceased = representing.isDeceased;
    this.createdByRepresentative = representing.createdByRepresentative;
    this.hasCompletedDossier = representing.hasCompletedDossier;
    this.hasCompletedOnBoarding = representing.hasCompletedOnBoarding;
    this.hasValidatedAllLetters = representing.hasValidatedAllLetters;
    this.etablissementId = representing.etablissementId;
    this.partnerId = representing.partnerId;
    this.hasDocumentSending = representing.hasDocumentSending;
}
module.exports = RepresentingUser;